import type { StringBank } from '../schema/strings';
export default {
  unknown: 'Mystery fossil',
  found: 'You dug up a mystery fossil!',
  trikeSkull: 'Triceratops skull', trikeTorso: 'Triceratops torso', trikeTail: 'Triceratops tail',
  rexSkull: 'T. rex skull', rexTorso: 'T. rex torso', rexTail: 'T. rex tail',
  stegoSkull: 'Stegosaurus skull', stegoTorso: 'Stegosaurus torso', stegoTail: 'Stegosaurus tail',
  pteraSkull: 'Pteranodon skull', pteraWing: 'Pteranodon wing',
  mammothSkull: 'Mammoth skull', mammothTorso: 'Mammoth torso',
  ammonite: 'Ammonite', trilobite: 'Trilobite', amber: 'Amber', dinoEgg: 'Dinosaur egg', dinoTrack: 'Dinosaur track',
  coprolite: 'Coprolite', sharkTooth: 'Shark tooth', sabertoothSkull: 'Sabre-tooth skull', archaeopteryx: 'Archaeopteryx',
  dunkleosteus: 'Dunkleosteus', eurypterid: 'Sea scorpion', fern: 'Fossil fern',
  setTrike: 'Triceratops', setRex: 'T. rex', setStego: 'Stegosaurus', setPtera: 'Pteranodon', setMammoth: 'Mammoth',
} as const satisfies StringBank;
